<template>
  <div class="box">
    <h5 class="title">章节列表：</h5>
    <ul>
      <li
        v-for="(item, index) in catalogObj"
        :key="index"
        @click="active(item, index)"
        :class="[index == activeIndex ? 'active2' : '']"
      >
        <span>{{ item.chapterName }}</span>
        <!-- <span class="time">{{item.hourLong}}min</span> -->
      </li>
    </ul>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: '',
  props: {
    catalogObj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    ...mapActions(['courseVideUrl']),
    active(item, index) {
      this.activeIndex = index;
      this.courseVideUrl(item.videoUrl);
      setTimeout(() => {
        document.querySelector('#ele_video').play();
      }, 500);
    }
  },
  watch: {
    catalogObj(v) {
      try {
        this.courseVideUrl(v[0].videoUrl);
      } catch (e) {
        console.error('没有章节catalog');
      }
    }
  },
  computed: {},
  components: {},
  created() {}
};
</script>
<style lang="less" scoped>
@import '../../../../public/style/g.less';

.box {
  margin-top: 0.56rem;
  .title {
    font-size: 0.4rem;
    margin-bottom: 0.27rem;
  }
  ul {
    overflow-x: scroll;
    display: -webkit-box;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 0.32rem;
    .active2 {
      color: #0a81fa;
    }
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 4.05rem;
      height: 1.81rem;
      margin-right: 0.27rem;
      padding: 0.2rem 0.47rem;
      background: #f6f7f9;
      font-size: 0.3733rem;
      border-radius: 0.11rem;
      span {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
